import { render } from "./EmptySection.vue?vue&type=template&id=bdad7a00&scoped=true"
import script from "./EmptySection.vue?vue&type=script&lang=js"
export * from "./EmptySection.vue?vue&type=script&lang=js"

import "./EmptySection.vue?vue&type=style&index=0&id=bdad7a00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdad7a00"]])

export default __exports__